module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/storm-4c52d641a54c582dba525465f4f9748b.svg";